import DefaultElementNodeType from '../DefaultElementNodeType';
import {TECHNOLOGY_NODE} from '../../metamodel/Concept';

export default class TechnologyNodeNodeType extends DefaultElementNodeType {
	static get typeName() {
		return TECHNOLOGY_NODE;
	}
}
